<template>
  <div
    v-if="!isCreativeLoading"
    v-show="iframeLoaded && templateSet.width > 0"
    class="overflow-hidden creative-wrapper mx-auto"
    :style="templateStyle"
  >
    <ContentAnnotations
      v-if="allowAnnotations && isCurrentCreative"
      :current-annotation.sync="currentAnnotation"
      :size="templateSet"
      :allow="allowAnnotations"
      :annotations="getAnnotations"
      @setCurrentAnnotation="setCurrentAnnotation"
    />
    <div v-if="!hasContentItem">
      no content
    </div>
    <iframe
      v-else
      class=""
      id="preview-iframe"
      :srcdoc="injectScript"
      title="content preview"
      marginwidth="0"
      marginheight="0"
      hspace="0"
      vspace="0"
      frameborder="0"
      scrolling="no"
      :height="`${templateSet.height}`"
      :width="`${templateSet.width}`"
      @load="iframeLoad"
    />
    <div
      v-if="!isCreativeContentActive || isContentItemPaused"
      :class="pausedOverlayClass"
    />
    <div class="creative-wrapper_bottom" />
  </div>
</template>

<script>
import ContentAnnotations from '@/modules/content/components/ContentAnnotations';

import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import * as types from '@/modules/content/store/types';

export default {
  name: 'RenderedTemplate',
  components: {
    ContentAnnotations,
  },
  props: {
    creativeSet: {
      type: Object,
      default: () => {},
    },
    contentItem: {
      type: Object,
      default: () => {},
    },
    currentCreativeId: {
      type: Number,
      default: null,
    },
    viewSize: {
      type: Object,
      default: () => {},
    },
    isCreativeLoading: {
      type: Boolean,
      default: false,
    },
    isCreativeContentActive: {
      type: Boolean,
      default: true,
    },
    isContentItemPaused: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iframeLoaded: false,
      templateSet: {},
      parent: this.$parent.$el,
      creativeScale: 'scale(1)',
    };
  },
  computed: {
    ...mapState('campaigns', [
      'selectedAdvertiser',
    ]),
    ...mapState('content', [
      'allowAnnotations',
      'currentAnnotation',
      'currentAnnotationState',
      'feedId',
      'timestamp',
    ]),
    ...mapGetters('content', {
      getAnnotations: types.GET_ANNOTATIONS,
    }),
    templateStyle() {
      return {
        width: `${this.templateSet.width}px`,
        'min-width': `${this.templateSet.width}px`,
        height: `${this.templateSet.height}px`,
        transform: this.creativeScale,
      };
    },
    injectScript() {
      if (!this.contentItem) return '';
      return `\x3cscript src="${process.env.VUE_APP_RENDER_API}/preview/creative/${this.creativeSet.id}/key/${this.creativeSet.creativeKey}/acid/${this.contentItem.encodedExternalId}?${this.timestamp}"\x3e\x3c/script\x3e`;
    },
    isCurrentCreative() {
      return this.currentCreativeId === this.creativeSet.id;
    },
    hasContentItem() {
      if (!this.contentItem) return false;
      return (Object.keys(this.contentItem).length >= 0);
    },
    getAdvertiserId() {
      if (this.selectedAdvertiser !== {}) {
        return this.selectedAdvertiser.id;
      }
      return 0;
    },
    pausedOverlayClass() {
      return (!this.isCreativeContentActive || this.isContentItemPaused) ? 'creative-paused' : '';
    },
  },
  methods: {
    ...mapActions('content', [
      types.GET_TEMPLATE_BY_ID,
      types.SET_CURRENT_ANNOTATION,
      types.REMOVE_CURRENT_ANNOTATION,
      types.FETCH_EXISTING_CREATIVES,
      types.TRIGGER_CREATIVE_RERENDER,
    ]),
    ...mapMutations('content', [
      types.CLEAR_CURRENT_COMMENTS,
    ]),
    setTimestamp() {
      this.setCreativeTemplate();
      this.iframeLoaded = false;
      this.TRIGGER_CREATIVE_RERENDER();
      if (this.currentAnnotationState) this.REMOVE_CURRENT_ANNOTATION();
      this.CLEAR_CURRENT_COMMENTS();
    },
    setCreativeTemplate() {
      const { creativeTemplateId } = this.creativeSet;
      this.GET_TEMPLATE_BY_ID(creativeTemplateId)
        .then((templateSet) => {
          this.templateSet = templateSet;
        });
    },
    setCurrentAnnotation(location) {
      this.SET_CURRENT_ANNOTATION(location);
    },
    iframeLoad() {
      this.iframeLoaded = true;
    },
    rerenderCreative() {
      this.setTimestamp();
    },
    calculateCreativeScale() {
      const { viewWidth, viewHeight } = this.viewSize;
      if (this.templateSet.height >= viewHeight) {
        const creativeScale = (viewHeight / this.templateSet.height);
        this.creativeScale = `scale(${creativeScale})`;
      } else if (this.templateSet.width >= viewWidth) {
        const creativeScale = (viewWidth / this.templateSet.width);
        const translateX = ((this.templateSet.width - (viewWidth + 75)) / 2);
        this.creativeScale = `scale(${creativeScale}) translateX(-${translateX * (1 + creativeScale)}px)`;
      }
    },
  },
  created() {
    this.setCreativeTemplate();
  },
  mounted() {
    this.$nextTick(() => {
    });
  },
  watch: {
    templateSet(newValue) {
      if (newValue) this.calculateCreativeScale();
    },
    contentItem(newval) {
      if (!newval) this.iframeLoaded = false;
      else this.iframeLoaded = true;
    },
  },
};
</script>
<style scoped>
.creative-wrapper{
  transform-origin: top;
  position: relative;
}
/* .iframe-container {

  width: 100%;
  height: 100%;
} */
.creative-paused {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: repeating-linear-gradient(15deg, #ddd, #ddd 70px, #aaa 70px, #aaa 140px);
  opacity: .7;
}
</style>
